// extracted by mini-css-extract-plugin
export default {"title":"TqPDM","summary":"vlYgZ","disclaimer":"qApEM","wrapper":"n6u3Y","disclaimerWrapper":"ImX0_","disclaimerIcon":"HyqFV"};